/* import __COLOCATED_TEMPLATE__ from './follow-up-options.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

export type FollowupOption = 'follow_up' | 'follow_up_with_escalation' | 'no_follow_up';

interface Signature {
  Args: {
    selectedOption: FollowupOption;
    setSelectedOption: (option: FollowupOption) => void;
    isReadOnly: boolean;
  };
}

export default class FollowUpOptions extends Component<Signature> {
  @service declare intl: IntlService;

  get options() {
    return [
      {
        value: 'follow_up',
        translationKey:
          'operator.fin.setup.setup-and-go-live.fin-followups.followup-options.fin-follows-up',
      },
      {
        value: 'follow_up_with_escalation',
        translationKey:
          'operator.fin.setup.setup-and-go-live.fin-followups.followup-options.fin-follows-up-handoff',
      },
      {
        value: 'no_follow_up',
        translationKey:
          'operator.fin.setup.setup-and-go-live.fin-followups.followup-options.no-follow-up',
      },
    ] as const;
  }

  get previewText() {
    switch (this.args.selectedOption) {
      case 'follow_up':
        return this.intl.t(
          'operator.fin.setup.setup-and-go-live.fin-followups.preview.fin-follows-up',
        );
      case 'follow_up_with_escalation':
        return this.intl.t(
          'operator.fin.setup.setup-and-go-live.fin-followups.preview.fin-follows-up-handoff',
        );
      default:
        return '';
    }
  }

  get shouldShowPreview() {
    return this.args.selectedOption !== 'no_follow_up';
  }

  @action
  handleOptionSelect(option: FollowupOption) {
    this.args.setSelectedOption(option);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::FollowUp::FollowUpOptions': typeof FollowUpOptions;
    'operator/fin/setup/sections/follow-up/follow-up-options': typeof FollowUpOptions;
  }
}
